import { HANDLE } from 'constants/bounding-box';

const BOUNDING_BOX_CONFIG = {
  customHandle: HANDLE.CORNERS,
};
const MIN_NR_ICONS = 1;
const MAX_NR_ICONS = 100;
const NR_OF_ICONS_DROPDOWN_OPTIONS = [5, 10, 50, 100];

const DEFAULT_SHAPE_COLOR_ONE = '#2B2B35';
const DEFAULT_SHAPE_COLOR_TWO = '#f64d2a';
const DEFAULT_NR_ICONS = 10;
const DEFAULT_GRID_ITEM_SIZE_PX = 42;
const DEFAULT_GRID_GAP_PX = 10;
const MAX_GAP_PX = 30;
const DEFAULT_MAX_SIZE_MONO = 80;
const DEFAULT_MAX_SIZE_COLOR = 160;

export {
  BOUNDING_BOX_CONFIG,
  MIN_NR_ICONS,
  MAX_NR_ICONS,
  NR_OF_ICONS_DROPDOWN_OPTIONS,
  DEFAULT_NR_ICONS,
  DEFAULT_GRID_ITEM_SIZE_PX,
  DEFAULT_GRID_GAP_PX,
  MAX_GAP_PX,
  DEFAULT_SHAPE_COLOR_ONE,
  DEFAULT_SHAPE_COLOR_TWO,
  DEFAULT_MAX_SIZE_MONO,
  DEFAULT_MAX_SIZE_COLOR,
};
